import React from "react";
import "./Switch.css";

export interface SwitchProps {
  /**
   * Whether the switch is checked
   */
  checked?: boolean;
  /**
   * Whether the switch is disabled
   */
  disabled?: boolean;
  /**
   * Callback function when switch state changes
   */
  onChange?: (checked: boolean) => void;
  /**
   * Additional class name
   */
  className?: string;
  /**
   * Label for accessibility
   */
  label?: string;
}

export const Switch: React.FC<SwitchProps> = ({
  checked = false,
  disabled = false,
  onChange,
  className = "",
  label,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const switchClasses = [
    "qida-switch",
    checked ? "qida-switch--checked" : "",
    disabled ? "qida-switch--disabled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="qida-switch__container">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        className={switchClasses}
        onClick={handleClick}
        disabled={disabled}
        aria-label={label}
      >
        <div className="qida-switch__track" />
        <div className="qida-switch__handle" />
      </button>
      {label && <span className="qida-switch__label">{label}</span>}
    </div>
  );
};

export default Switch;
